<template>
  <div class="bg-white rounded-xl shadow p-6">
    <!-- Header -->
    <div class="flex justify-between items-center mb-4">
      <div>
        <h2 class="text-xl font-semibold text-gray-800">Campaign Summary</h2>
        <span class="text-sm text-gray-500">
          {{ configs && configs.campaign_name ? configs.campaign_name : "—" }}
        </span>
      </div>

      <!-- Export Button -->
       <button
          class="bg-primary text-white px-4 py-2 rounded-lg shadow hover:bg-green-700 transition"
          @click="exportToCSV"
        >
          ⬇ Export CSV
        </button>
    </div>

    <!-- Metrics Grid -->
    <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4 mb-6">
      <div
        v-for="metric in metrics"
        :key="metric.label"
        class="p-4 border rounded-lg hover:shadow transition"
      >
        <p class="text-sm text-gray-500">{{ metric.label }}</p>
        <p class="text-2xl font-bold text-gray-800">{{ metric.value }}</p>
      </div>
    </div>

    <!-- Performance Chart -->
    <div class="h-64">
      <canvas id="campaignChart"></canvas>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Chart from "chart.js";

export default {
  name: "CampaignSummary",
  props: {
    configs: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      metrics: [
        { label: "Impressions", value: "0" },
        { label: "Clicks", value: "0" },
        { label: "CTR (%)", value: "0.00" },
        { label: "Conversions", value: "0" },
      ],
      chartInstance: null,
    };
  },
  mounted() {
    this.loadMetrics();
  },
  methods: {
    async loadMetrics() {
      try {
        const LOGIN_API_URL =
          "https://ads.brandfi.co.ke/ads/adsuiapi/login.php";

        const params1 = {
          username: "b.arudo@saritcentre.com",
          password: "b.arudo@saritcentre.com",
          client_id: "BrandFiApiUI",
          client_secret: "BrandFiApiUI",
          grant_type: "password",
        };

        const response1 = await axios.post(LOGIN_API_URL, params1, {
          headers: { "Content-Type": "application/json" },
        });
        const data1 = response1.data || {};

        const API_URL =
          "https://ads.brandfi.co.ke/ads/adsuiapi/agency/agency-dashboard.php?access_token=" +
          data1.access_token;

        const params = {
          date: 1,
          user_type_id: "15",
        };

        const response = await axios.post(API_URL, params);
        const data = response.data || {};

        console.log("Dashboard Data:", data);

        const impressions = (data.Impression || []).map((i) => Number(i));
        const clicks = (data.Clicks || []).map((c) => Number(c));
        const conversions = (data.Conversion || []).map((c) => Number(c));

        const totalImpressions = impressions.reduce((a, b) => a + b, 0);
        const totalClicks = clicks.reduce((a, b) => a + b, 0);
        const totalConversions = conversions.reduce((a, b) => a + b, 0);

        const ctr = totalImpressions
          ? ((totalClicks / totalImpressions) * 100).toFixed(2)
          : "0.00";

        this.metrics = [
          { label: "Impressions", value: totalImpressions.toLocaleString() },
          { label: "Clicks", value: totalClicks.toLocaleString() },
          { label: "CTR (%)", value: ctr },
          { label: "Conversions", value: totalConversions.toLocaleString() },
        ];

        if (this.chartInstance) {
          this.chartInstance.destroy();
        }

        const ctx = document.getElementById("campaignChart").getContext("2d");
        this.chartInstance = new Chart(ctx, {
          type: "line",
          data: {
            labels: data.Labels || [],
            datasets: [
              {
                label: "Impressions",
                data: impressions,
                borderColor: "#3B82F6",
                fill: false,
                tension: 0.3,
              },
              {
                label: "Clicks",
                data: clicks,
                borderColor: "#10B981",
                fill: false,
                tension: 0.3,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: { position: "bottom" },
            title: {
              display: true,
              text: "Campaign Performance (Hourly)",
            },
            scales: {
              yAxes: [
                {
                  ticks: { beginAtZero: true },
                },
              ],
              xAxes: [
                {
                  gridLines: { display: false },
                },
              ],
            },
          },
        });
      } catch (error) {
        console.error("Failed to load metrics:", error);
      }
    },

    exportToCSV() {
      // Convert metrics to CSV format
      const rows = [["Metric", "Value"]];
      this.metrics.forEach((m) => {
        rows.push([m.label, m.value]);
      });

      // Create CSV content
      const csvContent =
        "data:text/csv;charset=utf-8," +
        rows.map((e) => e.join(",")).join("\n");

      // Create a download link
      const link = document.createElement("a");
      link.setAttribute("href", encodeURI(csvContent));
      link.setAttribute(
        "download",
        `${this.configs.campaign_name || "campaign_summary"}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>
button {
  transition: all 0.2s ease-in-out;
}
</style>
